export enum DistributionColor {
    Red = 'rgb(255,0,0)',
    Orange = 'rgb(255,128,0)',
    Yellow = 'rgb(255,255,0)',
    Green = 'rgb(0,255,0)',
    DarkGreen = 'rgb(0,102,0)',
    Grey = 'rgb(102,102,102)',
    RedDotted = 'rgb(102,0,0)',
    Black = 'rgb(0,0,0)'
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/distribution-color.ts